<button
  class="button button-border button-border--medium"
  translate="account.button.add-demo-funds"
  (click)="accountActionsService.onAddDemoFundsClick(account)"
></button>
